import { getDefaultSearchPageFeedAPI } from "../../api/homeApi";
import { COUNTRIES } from "../../constants/common/common";

/**
 * Extracts feed slot items (`{ order, widget }`) for {@link Feed} — same shape as `DynamicHomePage`.
 * Do not use `normalizeFeedWidgets` here; `Feed` requires the wrapped feed item shape.
 *
 * @param {object|null|undefined} pageFeed - Raw search feed API response
 * @returns {Array<object>}
 */
export function getWidgetsFromPageFeedResponse(pageFeed) {
  if (!pageFeed) {
    return [];
  }

  if (Array.isArray(pageFeed.widgets)) {
    return pageFeed.widgets.filter((item) => item != null);
  }

  const stores = pageFeed.stores;
  if (!Array.isArray(stores) || stores.length === 0) {
    return [];
  }

  const selectedStore = stores.find((store) => store.isSelected) ?? stores[0];
  const storeWidgets = selectedStore?.feed?.widgets;
  return Array.isArray(storeWidgets) ? storeWidgets.filter((item) => item != null) : [];
}

/**
 * Fetches feed widgets for the default (empty) search panel.
 *
 * @param {Object} args
 * @param {boolean} args.isMobile - `platform=mobile` vs `desktop`
 * @param {string} [args.catalogId] - Maps to API `geoId`
 * @returns {Promise<Array<object>>} Normalized feed widgets, or empty array on failure
 */
export async function fetchDefaultSearchPageFeed({ isMobile, catalogId }) {
  try {
    const response = await getDefaultSearchPageFeedAPI({
      isMobile,
      geoId: catalogId || COUNTRIES.INDIA,
    });
    return getWidgetsFromPageFeedResponse(response);
  } catch (error) {
    console.error("Error fetching default search page feed:", error);
    return [];
  }
}
